export type ChatType = 1 | 2 | 3;
export namespace ChatType {
  export const Person: ChatType & 1 = 1;
  export const Ollie: ChatType & 2 = 2;
  export const OllieHelp: ChatType & 3 = 3;
}

export interface IChat {
  id: number;
  created_at: string;
  chats: IChatItem[];
}

export interface IPerson {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  profile_image: null
}

export interface IChatItem {
  id: number;
  created_at: string;
  type_id: ChatType;
  gerund: string;
  chat_id: number;
  message_id: number;
  content: string;
  content_array: string[];
  org_person_id: number;
  first_name: string;
  last_name: string;
  isStreaming?: boolean;
}

export interface IChatItemContent {
  message_id: number;
  question: string
}

export interface IResponse<T> {
  data: T,
  status: number;
}

export interface IOllieAnswer {
  style: string;
  ollie_question: string;
  chatgpt_q: string;
  gpt_model: string;
}

export interface SearchUser {
  first_name: string
  last_name: string
  org_person_id: number
}

export interface IPreferences {
  set_name: string,
  has_assessment: boolean,
  preferences: IOptions[]
}

export interface IOptions {
  option_id: number,
  value: boolean,
  option_name: string
}